// extracted by mini-css-extract-plugin
export default {"achievement-content__container":"styles_achievement-content__container__h5hdx"};